// assume valid
export default ({ coupon, shipping = 0, subtotal = 0, currency }) => {
  const { type, amount } = coupon;
  switch (type) {
    case "freeShipping":
      return shipping;
    case "pct":
      return Math.round(subtotal * amount) / 100;
    case "cash":
      if (!currency) {
        throw new Error("Unknown currency");
      }
      return amount[currency];
    default:
      throw new Error("Invalid coupon type");
  }
};



// WEBPACK FOOTER //
// ./src/lib/applyCoupon.js